import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=f8acd6a2&scoped=true&"
import script from "./Voting.vue?vue&type=script&lang=js&"
export * from "./Voting.vue?vue&type=script&lang=js&"
import style0 from "./Voting.vue?vue&type=style&index=0&id=f8acd6a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8acd6a2",
  null
  
)

export default component.exports